const LOCAL_STORAGE_KEYS = {
  C1UserType: 'C1_USER_TYPE',
}

module.exports = {
  LOCAL_STORAGE_KEYS,
}
